import { GalleryVideo } from '@/lib/index';

export const galleryVideos: GalleryVideo[] = [
  // Profile
  {
    id: 'keshhav-profile',
    title: 'Keshhav Panneriy Film Director Video Profile',
    description: 'An in-depth profile of acclaimed film director Keshhav Panneriy, showcasing his journey, vision, and contributions to international cinema.',
    url: 'https://www.youtube.com/watch?v=KegXquRsj-0',
    platform: 'youtube',
    category: 'profile',
  },

  // Trailers & Teasers
  {
    id: 'jeena-theatrical-trailer',
    title: 'Jeena Isi Ka Naam Hai - Official Theatrical Trailer',
    description: 'The official theatrical trailer for the Bollywood entertainer starring Arbaaz Khan, Ashutosh Rana, and ensemble cast.',
    url: 'https://www.youtube.com/watch?v=R673mgPaM-8',
    platform: 'youtube',
    category: 'trailers',
  },
  {
    id: 'jeena-international-teaser',
    title: 'Jeena Isi Ka Naam Hai - International Teaser',
    description: 'International teaser showcasing the universal themes and cross-cultural appeal of the film.',
    url: 'https://www.youtube.com/watch?v=Xo2AECCx3tc',
    platform: 'youtube',
    category: 'trailers',
  },
  {
    id: 'jeena-title-song-teaser',
    title: 'Jeena Isi Ka Naam Hai - Title Song Teaser',
    description: 'Teaser for the movie\'s title song, featuring the film\'s musical highlights.',
    url: 'https://www.youtube.com/watch?v=bKc9CXy1c3E',
    platform: 'youtube',
    category: 'trailers',
  },
  {
    id: 'catfight-trailer',
    title: 'CATFIGHT - Official Trailer',
    description: 'Official trailer for the award-winning LGBTQ+ drama that has won 109+ international film festival awards.',
    url: 'https://youtu.be/u7XN6EqZb10',
    platform: 'youtube',
    category: 'trailers',
  },

  // Events
  {
    id: 'jeena-title-launch',
    title: 'Jeena Isi Ka Naam Hai - Title Launch Event',
    description: 'Star-studded title launch event featuring the cast and crew of Jeena Isi Ka Naam Hai.',
    url: 'https://youtu.be/Ngj1jTUZzXE',
    platform: 'youtube',
    category: 'events',
  },
  {
    id: 'jeena-music-launch',
    title: 'Jeena Isi Ka Naam Hai - Music Launch Event',
    description: 'Grand music launch event celebrating the film\'s soundtrack with the cast and music team.',
    url: 'https://www.youtube.com/watch?v=qEXy3UJKwKU',
    platform: 'youtube',
    category: 'events',
  },
  {
    id: 'cinema-etiquette',
    title: 'Bibia Films Studios Cinema Etiquette Video',
    description: 'Cinema audience etiquette video featuring legendary actor Ashutosh Rana, promoting respectful theater behavior.',
    url: 'https://www.youtube.com/watch?v=vix0_Aip7YA',
    platform: 'youtube',
    category: 'events',
  },
  {
    id: 'eternal-love-premiere',
    title: 'Eternal Love - 3D Stereoscopic Movie Premiere',
    description: 'Premiere event of India\'s first stereoscopic 3D musical short film, showcasing groundbreaking technology.',
    url: 'https://www.youtube.com/watch?v=YwcKJLb8OAg',
    platform: 'youtube',
    category: 'events',
  },
  {
    id: 'catfight-interview',
    title: 'CATFIGHT - Filmmaker Keshhav Panneriy Interview',
    description: 'Film festival interview with Robert Jerome Pagan discussing CATFIGHT: A Love Story with a Twist.',
    url: 'https://www.youtube.com/watch?v=adQACSRs-yU',
    platform: 'youtube',
    category: 'events',
  },

  // Behind The Scenes - CATFIGHT
  {
    id: 'catfight-bts',
    title: 'CATFIGHT - Behind The Scenes',
    description: 'Exclusive behind-the-scenes footage from the making of the award-winning LGBTQ+ drama.',
    url: 'https://youtu.be/e-3gkQP_32c',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'catfight-feedback',
    title: 'CATFIGHT - International Audience Feedback',
    description: 'International audience reactions and feedback for the critically acclaimed film CATFIGHT.',
    url: 'https://www.youtube.com/watch?v=IRbgxDpmu1Q',
    platform: 'youtube',
    category: 'behind-scenes',
  },

  // Behind The Scenes - Jeena Isi Ka Naam Hai
  {
    id: 'jeena-bts-compiled',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes Compilation',
    description: 'Complete compilation of behind-the-scenes footage from the sets of Jeena Isi Ka Naam Hai.',
    url: 'https://www.youtube.com/watch?v=yDz1jGBqStE',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-tiger-scene',
    title: 'Jeena Isi Ka Naam Hai - Dangerous Tiger Scene',
    description: 'Behind-the-scenes of the thrilling tiger scene shoot, showcasing the film\'s ambitious production.',
    url: 'https://www.youtube.com/watch?v=raVDi9c1szc',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-usa-fun',
    title: 'Jeena Isi Ka Naam Hai - USA Behind The Scenes Fun',
    description: 'Fun moments and candid footage from the USA shooting schedule.',
    url: 'https://youtu.be/G_GY3LXFCpU',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-weather-villain',
    title: 'Jeena Isi Ka Naam Hai - Weather Plays Villain',
    description: 'Behind-the-scenes challenges faced during USA and India shoots when weather became the biggest obstacle.',
    url: 'https://youtu.be/25zNQ5Mh-oc',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-indo-us-crew',
    title: 'Jeena Isi Ka Naam Hai - Indo-US Crew',
    description: 'Behind-the-scenes featuring the international collaboration between Indian and US film crews.',
    url: 'https://youtu.be/tzfgQtb6urI',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-usa-work-action',
    title: 'Jeena Isi Ka Naam Hai - USA Work in Action',
    description: 'Behind-the-scenes video showcasing the production work during USA shooting schedule.',
    url: 'https://youtu.be/x1Czw7AxO4I',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-usa-media',
    title: 'Jeena Isi Ka Naam Hai - USA Media on Set',
    description: 'American media reporters visiting the film set during USA production.',
    url: 'https://youtu.be/DMh6egqGWzA',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-american-bts',
    title: 'Jeena Isi Ka Naam Hai - American BTS Shoot',
    description: 'Behind-the-scenes footage from the American shooting locations.',
    url: 'https://youtu.be/8ib2uJVegyU',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-1',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 1',
    description: 'Additional behind-the-scenes footage from the film production.',
    url: 'https://youtu.be/woDbQmj1baU',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-2',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 2',
    description: 'More exclusive behind-the-scenes content from the film sets.',
    url: 'https://youtu.be/eOKR7cO9GRc',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-3',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 3',
    description: 'Additional production footage and behind-the-scenes moments.',
    url: 'https://youtu.be/CvoEUPsly-M',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-4',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 4',
    description: 'More behind-the-scenes content showcasing the film production.',
    url: 'https://youtu.be/qBKqdcSA0rQ',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-5',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 5',
    description: 'Exclusive production footage from various shooting locations.',
    url: 'https://youtu.be/RF7tjuqrTX0',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-6',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 6',
    description: 'Additional behind-the-scenes moments from the film production.',
    url: 'https://youtu.be/lXFX4uhyL00',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-7',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 7',
    description: 'More exclusive content from the film sets and production.',
    url: 'https://youtu.be/XEAeRKFjq-s',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-8',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 8',
    description: 'Behind-the-scenes footage showcasing the filmmaking process.',
    url: 'https://youtu.be/cFt2XIJK1V8',
    platform: 'youtube',
    category: 'behind-scenes',
  },
  {
    id: 'jeena-bts-9',
    title: 'Jeena Isi Ka Naam Hai - Behind The Scenes 9',
    description: 'Final collection of behind-the-scenes content from the production.',
    url: 'https://youtu.be/7FtJgg6LhDQ',
    platform: 'youtube',
    category: 'behind-scenes',
  },

  // Songs Behind The Scenes
  {
    id: 'jeena-qubool-hai',
    title: 'Jeena Isi Ka Naam Hai - Qubool Hai Song Shoot',
    description: 'Behind-the-scenes of the romantic song "Qubool Hai" shoot.',
    url: 'https://youtu.be/EwRmlg2ulFA',
    platform: 'youtube',
    category: 'songs',
  },
  {
    id: 'jeena-mujhko-tere',
    title: 'Jeena Isi Ka Naam Hai - Mujhko Tere Ishq Mian Song Shoot',
    description: 'Behind-the-scenes of the melodious song "Mujhko Tere Ishq Mian" shoot.',
    url: 'https://youtu.be/lYErwCStkKQ',
    platform: 'youtube',
    category: 'songs',
  },

  // Character Introductions
  {
    id: 'jeena-ashutosh-rana',
    title: 'Character Intro: Ashutosh Rana as Vikram Singh',
    description: 'Character introduction featuring legendary actor Ashutosh Rana in his powerful role as Vikram Singh.',
    url: 'https://youtu.be/GVdYoj0qQFs',
    platform: 'youtube',
    category: 'character-intro',
  },
  {
    id: 'jeena-arbaaz-khan',
    title: 'Character Intro: Arbaaz Khan as Aditya Kapoor',
    description: 'Character introduction featuring Arbaaz Khan in his charismatic role as Aditya Kapoor.',
    url: 'https://youtu.be/Uci1tN3UGQs',
    platform: 'youtube',
    category: 'character-intro',
  },
  {
    id: 'jeena-supriya-pathak',
    title: 'Character Intro: Supriya Pathak as Lakshmi',
    description: 'Character introduction featuring acclaimed actress Supriya Pathak as Lakshmi.',
    url: 'https://youtu.be/9cYX13_JKNI',
    platform: 'youtube',
    category: 'character-intro',
  },
  {
    id: 'jeena-himansh-kohli',
    title: 'Character Intro: Himansh Kohli as Alex',
    description: 'Character introduction featuring Himansh Kohli in his role as Alex.',
    url: 'https://youtu.be/68oHJ9Rn6R8',
    platform: 'youtube',
    category: 'character-intro',
  },
  {
    id: 'jeena-prem-chopra',
    title: 'Character Intro: Prem Chopra as Shaukat Ali Mirza',
    description: 'Character introduction featuring legendary Bollywood actor Prem Chopra as Shaukat Ali Mirza.',
    url: 'https://youtu.be/vP9-vFpyITU',
    platform: 'youtube',
    category: 'character-intro',
  },
  {
    id: 'jeena-manjari-fadnnis',
    title: 'Character Intro: Manjari Fadnnis',
    description: 'Character introduction featuring talented actress Manjari Fadnnis.',
    url: 'https://youtu.be/ULC-3SUCSTY',
    platform: 'youtube',
    category: 'character-intro',
  },

  // Other Projects
  {
    id: 'eternal-love-bts',
    title: 'Eternal Love - Behind The Scenes',
    description: 'Behind-the-scenes of India\'s first stereoscopic 3D musical short film, showcasing groundbreaking technology.',
    url: 'https://www.youtube.com/watch?v=iF9jd0Wu_-I',
    platform: 'youtube',
    category: 'behind-scenes',
  },
];
